/* Wont Miss Garage - production image-slot element (replaces the design tool editor slot).
   Resolves images from window.WMG_IMAGES[id]; empty slots render the designed placeholder. */
(function () {
  var css = "image-slot{position:absolute;inset:0;display:block;overflow:hidden;}" +
    "image-slot .wmg-slot-img{position:absolute;inset:0;width:100%;height:100%;display:block;}" +
    "image-slot .wmg-slot-ph{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;text-align:center;padding:10px;color:#6f6c64;font-family:'JetBrains Mono',monospace;font-size:9px;letter-spacing:0.14em;text-transform:uppercase;line-height:1.6;}" +
    "image-slot .wmg-slot-ph::after{content:'';position:absolute;inset:8px;border:1.5px dashed rgba(111,108,100,0.5);pointer-events:none;}";
  var st = document.createElement("style");
  st.textContent = css;
  document.head.appendChild(st);

  var WmgImageSlot = function () { return Reflect.construct(HTMLElement, [], WmgImageSlot); };
  WmgImageSlot.prototype = Object.create(HTMLElement.prototype);
  WmgImageSlot.prototype.constructor = WmgImageSlot;
  Object.setPrototypeOf(WmgImageSlot, HTMLElement);

  WmgImageSlot.prototype.connectedCallback = function () {
    var self = this;
    this._render();
    this._iv = setInterval(function () { self._render(); }, 300);
  };
  WmgImageSlot.prototype.disconnectedCallback = function () { clearInterval(this._iv); };
  WmgImageSlot.prototype._render = function () {
    var id = this.getAttribute("id") || "";
    var map = window.WMG_IMAGES || {};
    var src = map[id] || "";
    if (src && this._src === src) return;
    if (!src && this._empty) return;
    this.innerHTML = "";
    if (src) {
      this._src = src;
      this._empty = false;
      var img = document.createElement("img");
      img.className = "wmg-slot-img";
      img.alt = this.getAttribute("placeholder") || "";
      img.loading = "lazy";
      img.style.objectFit = this.getAttribute("fit") === "contain" ? "contain" : "cover";
      img.src = src;
      this.appendChild(img);
      this.setAttribute("data-filled", "1");
    } else {
      this._empty = true;
      this._src = null;
      this.removeAttribute("data-filled");
      var ph = document.createElement("div");
      ph.className = "wmg-slot-ph";
      ph.textContent = this.getAttribute("placeholder") || "";
      this.appendChild(ph);
    }
  };
  if (!window.customElements.get("image-slot")) window.customElements.define("image-slot", WmgImageSlot);
})();
